import { bl_pos_hold_bill_hdr_RowClass } from '../../../dbschema';
import {BaseContainerModel} from '../../base-container.model';

export class PosHoldBillHdrContainerModel extends BaseContainerModel {
  bl_pos_hold_bill_hdr: bl_pos_hold_bill_hdr_RowClass = new bl_pos_hold_bill_hdr_RowClass();
}